<div class="full-page bg-primary w-100">
  <div class="text-center">
    <img class="logo" aria-labelledby="homeLink" src="assets/images/club-bear-logo.svg" draggable="false" />
    <div class="terms-container">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
